import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ErrorFloodThrottle, Logger } from '@anduin/shared';
import { take, tap } from 'rxjs/operators';
import { ChunkErrorDialogComponent } from './chunk-error-dialog/chunk-error-dialog.component';

const CHUNK_LOAD_ERROR_MESSAGE = /Loading chunk [\d]+ failed|Failed to fetch dynamically imported module/;

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandlerService implements ErrorHandler {
  private readonly throttle = new ErrorFloodThrottle((suppressedCount, signature) =>
    this.logger.warn(`GlobalErrorHandler: suppressed ${suppressedCount} duplicate error(s) for "${signature}"`),
  );

  constructor(
    private readonly dialog: MatDialog,
    private readonly zone: NgZone,
    private readonly logger: Logger,
  ) {}

  handleError(error: any): void {
    // A single throw inside change detection re-fires every tick; logging each one floods
    // LogRocket's per-minute exception cap and suppresses the real error. Throttle duplicates.
    if (this.throttle.shouldLog(error)) {
      this.logger.error(error);
    }

    // If a chunk failed to load, alert the user and reload.
    if (CHUNK_LOAD_ERROR_MESSAGE.test(error?.message)) {
      // Run from THE ZONE - encountered some inconsistent modal loads; and naturally, zone shenanigans fix everything
      this.zone.run(() =>
        this.dialog
          .open(ChunkErrorDialogComponent, { disableClose: true })
          .afterClosed()
          .pipe(
            tap((response) => {
              if (response) {
                window.location.reload();
              }
            }),
            take(1),
          )
          .subscribe(),
      );
    }
  }
}
